import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TabBase } from './types';

export const TabAction = (
  props: Pick<TabBase, 'id' | 'onClick' | 'to' | 'pushLocationState'> & { children: ReactNode; className: string },
) => {
  const location = useLocation();

  if (!props.to) {
    return (
      <button id={props.id} onClick={props.onClick} className={props.className}>
        {props.children}
      </button>
    );
  } else {
    if (props.to && props.to.startsWith('/')) {
      const hasQuery = props.to.includes('?');
      const [pathname, search] = hasQuery ? props.to.split('?') : [props.to, ''];

      const to = {
        pathname,
        search,
        state: { from: location.pathname },
      };

      if (props.pushLocationState) {
        to['state'] = { ...to.state, ...props.pushLocationState };
      }

      return (
        <Link id={props.id} to={to} onClick={props.onClick} className={props.className}>
          {props.children}
        </Link>
      );
    } else {
      return (
        <a id={props.id} href={props.to} onClick={props.onClick} className={props.className}>
          {props.children}
        </a>
      );
    }
  }
};
